import React, { useState } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaNumber from "../../../../ui-kit/kuika-number/kuika-number";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

const capAtNine = (value: number): string => (value > 9 ? "9+" : String(value));

export const NumberStory: React.FC = (): JSX.Element => {
  const [count, setCount] = useState<number>(998);
  const [credits, setCredits] = useState<number>(12480);
  const [unread, setUnread] = useState<number>(7);

  return (
    <ShowcaseFrame
      title="Number"
      componentName="KuikaNumber"
      sourcePath="ui-kit/kuika-number"
      description="A live number whose changed digits roll — up when it grows, down when it shrinks — while unchanged digits stay still. Formatted en-US by default."
    >
      <SpecRow label="Step" caption="998 → 999 → 1,000 grows a separator slot and a leading digit, both roll in">
        <span style={{ fontSize: 20 }}>
          <KuikaNumber value={count} />
        </span>
        <KuikaButton type="secondary" size="sm" onClick={(): void => setCount(count - 1)}>
          −1
        </KuikaButton>
        <KuikaButton type="primary" size="sm" onClick={(): void => setCount(count + 1)}>
          +1
        </KuikaButton>
      </SpecRow>
      <SpecRow label="Spend" caption="a credit balance going down rolls every changed digit downwards">
        <span style={{ fontSize: 20 }}>
          <KuikaNumber value={credits} />
        </span>
        <KuikaButton type="secondary" size="sm" onClick={(): void => setCredits(Math.max(0, credits - 137))}>
          Spend 137
        </KuikaButton>
        <KuikaButton type="primary" size="sm" onClick={(): void => setCredits(credits + 2500)}>
          Top up 2,500
        </KuikaButton>
      </SpecRow>
      <SpecRow label="Custom format" caption="format caps the text — a count past 9 shows 9+">
        <KuikaNumber value={unread} format={capAtNine} />
        <KuikaButton type="secondary" size="sm" onClick={(): void => setUnread(Math.max(0, unread - 1))}>
          Read one
        </KuikaButton>
        <KuikaButton type="primary" size="sm" onClick={(): void => setUnread(unread + 1)}>
          New message
        </KuikaButton>
      </SpecRow>
    </ShowcaseFrame>
  );
};
